module.exports = ".download-file-link {\n  text-align: left;\n  margin-bottom: 10px; }\n  .download-file-link .label {\n    font-weight: bold;\n    color: black;\n    font-size: 14px; }\n  :host .form-group {\n  overflow: initial;\n  display: initial; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/+assets/asset-email-modal/asset-email.scss
// module id = ./src/app/+assets/asset-email-modal/asset-email.scss
// module chunks = main